export default __webpack_public_path__ + "static/media/093-scroll.243dcc46.png";